import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './Header';
import PremiumArchitectureWebsite from './home';
import AboutPage from './about';
import MaaSrinivasamPage from './Projects/srinivas';
import MaaGarudadriPage from './Projects/garudadri';
import ScrollToTop from './scrolltop';

import Footer from './Footer';

import ContactPage from './contact';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<PremiumArchitectureWebsite />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/Projects/srinivas" element={<MaaSrinivasamPage />} />
          <Route path="/Projects/garudadri" element={<MaaGarudadriPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;